import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Button } from 'primereact/button';
import CustomTooltip from '../../../../../shared/components/common/tooltip/CustomTooltip';
import PieChartWithLegend from '../../../../../shared/components/chart/pie-chart-with-legend/PieChartWithLegend';
import EmptyPanel from '../../../../../shared/components/empty-panel/EmptyPanel';
import { PieChartData } from '../../../../../shared/models/common/PieChartData';
import { t } from 'i18next';
import { SOV_PIE_CHART_PALETTE } from '../../../../../shared/utils/sovPalette';

interface ShareOfVoiceChartProps {
  shareOfVoiceData: PieChartData[] | undefined;
  hasAnyPendingQuestions: boolean;
  firmName: string;
  hasProjectStatsData: boolean;
  onSettingsClick: () => void;
  isLoading: boolean;
}

const ShareOfVoicePieChart: React.FC<ShareOfVoiceChartProps> = ({
  shareOfVoiceData,
  hasAnyPendingQuestions,
  firmName,
  hasProjectStatsData,
  onSettingsClick,
  isLoading,
}) => {
  const hasData = !!shareOfVoiceData && shareOfVoiceData.length > 0;
  const hasOnlyOthers =
    shareOfVoiceData && shareOfVoiceData.length === 1 && shareOfVoiceData[0].name === t('others');
  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('shareOfVoice')}
          <CustomTooltip tooltipText="shareOfVoiceTooltip" addMargin={false} />
        </div>
      </div>
      {(!hasData || hasOnlyOthers) && !hasProjectStatsData && !isLoading ? (
        <div className="stats-box stats-box--pie-chart stats-box--empty">
          <div className="stats-box__content stats-box__content--empty">
            <EmptyPanel />
          </div>
        </div>
      ) : (!hasProjectStatsData && hasAnyPendingQuestions) || isLoading ? (
        <div className="stats-box stats-box--pie-chart">
          <div className="stats-box__content">
            <Skeleton className="skeleton--chart-pie">
              <span />
              <span />
              <span />
            </Skeleton>
          </div>
        </div>
      ) : (
        <div className="stats-box stats-box--pie-chart">
          <div className="stats-box__content">
            <Button id="btn-settings-pie" className="action-btn" onClick={onSettingsClick}>
              <span className="ico--settings ico--xs" />
            </Button>
            <CustomTooltip tooltipText="chooseBrandsToCompare" targetRef="btn-settings-pie" />
            <PieChartWithLegend
              chartData={shareOfVoiceData!}
              colorPalette={SOV_PIE_CHART_PALETTE}
              selectedBrand={firmName}
              size="SM"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareOfVoicePieChart;
